import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'help_center-back_to-click';
/**
 * After user fills out survey, they can either click back to help center or back to Faire.com. We need to track which one is clicked more
 */
export function trackHelpCenterBackToClick(target) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { target },
    });
}
